import src from "IMAGE";
export default { src, width: 420, height: 198, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAJ0lEQVR42oXKMRIAAAQDQf9/rpKRUGjDzVy3RlWC9KJJUHPgANsLGtcsf2ViIdaQAAAAAElFTkSuQmCC"};
